<template>

  <div class="products">   
    <div class="container">
     
        
        <div class="row">
        <div class="col-md-12 order-md-2">
           
          <template v-if="product_duplicate.length == 0 || products_list.length == 0">
          </template>
          <template v-else>
          <div class="row" v-if="show_paginado">
            
              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{current_page}} de {{final_page}}</small>
                </div>
                  <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm">
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                      </template>
                      <template v-if="current_page > 1">
                        <li role="none presentation" class="page-item" aria-hidden="true" @click="listadoPagina(current_page - 1)"><span class="page-link page-selector">‹</span></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                      </template>
                      <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page === current_page) ? 'active' : '']" @click="listadoPagina(page)"><a role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</a></li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(current_page + 1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(final_page)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>

            <div class="col-md-12">
               <!-- <h4 class="mb-3">Billing address</h4> -->
              <card-loader :loopCount=16 v-if="loading"/>
              <!--products-list :products_list="product_duplicate.productos" />-->
              <div class="row">
                <div class="col-sm-6 col-md-4 col-lg-3" v-for="(item, index) in product_duplicate" :key="index">
                  <card-template :item="item.productos" />
                </div>
              </div>
              
            </div>

              <div class="col-md-12">
                <div style="float: left; padding-right: calc(0.5%);">
                  <small>Mostrando pagina {{current_page}} de {{final_page}}</small>
                </div>
                  <!-- Paginado -->
                <div style="float: right; padding-right: calc(0.5%);">
                  <nav>
                    <ul role="menubar" aria-disabled="false" aria-label="Pagination" class="pagination b-pagination pagination-sm">
                      <template v-if="current_page == 1">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">«</span></a></li>
                      </template>
                      <template v-if="current_page > 1">
                        <li role="none presentation" class="page-item" aria-hidden="true" @click="listadoPagina(current_page - 1)"><span class="page-link page-selector">‹</span></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item disabled" aria-hidden="true"><span class="page-link page-selector" >‹</span></li>
                      </template>
                      <li v-for="page in pages" :key="page" role="none presentation" :class="['page-item', (page === current_page) ? 'active' : '']" @click="listadoPagina(page)"><a role="menuitemradio" tabindex="-1" aria-label="Goto page 2" aria-checked="false" aria-posinset="2" aria-setsize="4" target="_self" class="page-link page-selector">{{page}}</a></li>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(current_page + 1)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link" ><span aria-hidden="true" class="page-selector">›</span></a></li>
                      </template>
                      <template v-if="current_page == final_page">
                        <li role="none presentation" class="page-item disabled"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                      <template v-else>
                        <li role="none presentation" class="page-item" @click="listadoPagina(final_page)"><a role="menuitem" tabindex="-1" aria-label="Goto next page" target="_self" class="page-link"><span class="page-selector" aria-hidden="true">»</span></a></li>
                      </template>
                    </ul>
                  </nav>
                </div>
              </div>

          </div>
          </template> 

        </div>
      </div>
    </div>
    <TwoModules></TwoModules>
    <NewModules></NewModules>
  </div>
   
</template>


<script>
import TwoModules from "@/components/products/TwoModules.vue";
import NewModules from "@/components/products/NewModule.vue";
import ProductsList from "@/components/products/ProductsList";
import CardLoader from "@/components/shared/CardLoader";
import ProductFilter from "@/components/products/filters/ProductFilter"
import axios from "axios";
import _ from "lodash";
import {config_settings} from '../config.js';
import { errorToaster } from '../components/shared/service/ErrorHandler';
import CardTemplate from "../components/shared/CardTemplate";

//HTTP ERROR STATUS
  const NOT_FOUND = 404;
  const BAD_REQUEST = 400;
  const UNAUTHORIZED = 401;
  const INTERNAL_SERVER_ERROR = 500;

  axios.interceptors.response.use(function (response) { return response; }, 
  function (error) {
    
    if(error.message === 'Network Error'){
      toastr.error("No se puede conectar con el servidor. Verifique su conexión a internet",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
    }
    else if(error.response.status === UNAUTHORIZED){
      if(error.response.data.message === "Access is denied"){
         toastr.error("Usted no tiene los provilegios para acceder a esta sección",
                       "ERROR",
                       {"iconClass": 'customer-danger'});
      }
      else {
        return Promise.reject(error);
      }
    }
    else {
      return Promise.reject(error);
    }
});

export default {
  name: "allProducts",
  components: { ProductsList, CardLoader, ProductFilter, TwoModules, NewModules, CardTemplate},
  data() {
    return {
      page_title: "",
      page_description: "",
      page_keywords: "",

      imgPreUrl : config_settings.PHOTO_SERVER_URL+'/',
      cod_sub_sec: 1,
      nom_sub_sec_es: '',
      nom_sub_sec_en: '',
      internal_name_es: '',
      internal_name_en: '',
      desc_sub_section_es: '',
      desc_sub_section_en: '',
      section: '',
      url_1st_image: 'products/empty-img',
      url_2nd_image: 'products/empty-img',
      url_3rd_image: 'products/empty-img',
      url_4th_image: 'products/empty-img',
      url_5th_image: 'products/empty-img',
      type_1st_image: 'image',
      type_2nd_image: 'image',
      type_3rd_image: 'image',
      type_4th_image: 'image',
      type_5th_image: 'image',
      text1_es: '',
      text1_en: '',
      text2_es: '',
      text2_en: '',
      text3_es: '',
      text3_en: '',
      orientation: '',
      url_es: '',
      url_en: '',
      order_sub_section: '',
      id_position_menu: '',
      url_video: '',
      type: '',
      categories: [],
      subcategories: [],
      sellers: [],
      products_list: [],
      product_duplicate: [],
      loading: false,
      pages: [],
      current_page : 1,
      final_page: 1,
      crit: 12, //number of products per page
      cate_filter: this.$route.params.cate,
      subcate_filter: this.$route.params.subcate,
      subcategoria: this.$route.params.subcate,
      categoria: this.$route.params.cate,
      criterio: '',
      criterio_categoria: '',
      mensaje: '',
      mensaje_error: '',

      show_paginado: false,
      filter_category: false,
    };
  },

  metaInfo() {

        return {
             title:  this.page_title ? this.page_title : "",
             meta: [
              { name: 'description', content: this.page_description ? this.page_description : "" },
              { name: 'keywords', content: this.page_keywords ? this.page_keywords : "" },
              { name: 'robots', content: "index" }
            ]
        }
  },
  
  methods: {
    ocultar(){
       this.mensaje = ""
       this.mensaje_error = ""
    },
    
    obtener_sub_section_data(){
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/sub_sections/'+ this.cod_sub_sec)
           .then(response => {
              
              this.nom_sub_sec_es = response.data.nom_sub_sec_es
              this.nom_sub_sec_en = response.data.nom_sub_sec_en
              this.internal_name_es = response.data.internal_name_es
              this.internal_name_en  = response.data.internal_name_en  
              this.desc_sub_section_es = response.data.desc_sub_section_es  
              this.desc_sub_section_en = response.data.desc_sub_section_en  
              this.section = response.data.section  
              this.url_1st_image = response.data.url_1st_image  
              this.url_2nd_image = response.data.url_2nd_image  
              this.url_3rd_image = response.data.url_3rd_image  
              this.url_4th_image = response.data.url_4th_image  
              this.url_5th_image = response.data.url_5th_image  
              this.type_1st_image = response.data.type_1st_image  
              this.type_2nd_image = response.data.type_2nd_image  
              this.type_3rd_image = response.data.type_3rd_image  
              this.type_4th_image = response.data.type_4th_image  
              this.type_5th_image = response.data.type_5th_image  
              this.text1_es = response.data.text1_es  
              this.text1_en = response.data.text1_en 
              this.text2_es = response.data.text2_es  
              this.text2_en = response.data.text2_en  
              this.text3_es = response.data.text3_es  
              this.text3_en = response.data.text3_en  
              this.orientation = response.data.orientation  
              this.url_es = response.data.url_es  
              this.url_en = response.data.url_en  
              this.order_sub_section = response.data.order_sub_section  
              this.id_position_menu = response.data.id_position_menu  
              this.url_video = response.data.url_video 
              this.type = response.data.type 
              
              //SEO
              this.page_title = this.nom_sub_sec_es;
              this.page_description = this.desc_sub_section_es;
              this.page_keywords = response.data.keywords;
               
             
          })
           .catch(error => {
            console.log("error");
      })
    },

    scroll_inicio() {
      window.scrollTo(0,0);
    },

    listar_productos_catalogo() {
      this.loading = true;
      axios.get(config_settings.RESOURCE_SERVER_URL + '/GET/catalog/products/offers?cReg='+this.crit)
           .then(response => {
             this.loading = false;
             this.products_list = response.data.offer;
             this.product_duplicate = response.data.offer;
             this.pages = response.data.visible_pages
             this.final_page = response.data.final_page
             this.current_page = 1
             this.mensaje_error = ""
             this.mensaje = ""
             this.show_paginado = true;
           })
           .catch(error => {
            this.products_list = [];
            this.product_duplicate = [];
            this.loading = false;
            this.mensaje_error = "No se encontraron resultados de la busqueda filtrada.";
            this.mensaje = "";
            this.show_paginado = true;
           })
    },

    listadoPagina (page) {
      this.loading = true;
      axios.get(config_settings.RESOURCE_SERVER_URL+ '/GET/catalog/products/offers?cReg='+this.crit+'&&nPag='+page+'')
           .then(response => {
              var arreglo = response.data.offer
              if(arreglo.length==0) { this.listadoPagina(page - 1) }
              this.loading = false;
              this.products_list = response.data.offer;
              this.product_duplicate = response.data.offer;
              this.pages = response.data.visible_pages
              this.final_page = response.data.final_page
              this.current_page = page
              this.scroll_inicio();
            })
            .catch(error => {
              this.loading = false;
              if(error.response.status === NOT_FOUND){ this.listadoPagina(page-1); }  
              else {
                  toastr.error(error.response.data.details,
                        error.response.data.message,
                        {"iconClass": 'customer-danger'});
                        this.mensaje_error = "No se encontraron resultados de la busqueda filtrada.";
                        this.mensaje = "";
        }  
      })
    }
  },

  created() {
    //this.getAllProducts();
    this.scroll_inicio();
    this.obtener_sub_section_data();
    this.listar_productos_catalogo();
  },

}
</script>

<style lang="scss">
.products {
  padding-top: 20px;
  @media(min-width:992px) {
     padding-top: 130px;
  }
}

.form-control {
  font-size: 13.5px;
}


</style>
